/* eslint-disable react/no-unescaped-entities */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../utilities/routes";

function LoginForm({
  onClick,
  onChange,
  onKeyPress,
  errors,
  user,
  loginButton,
  showPassword,
  passwordType,
}) {
  return (
    <div className="login-bg sign-up-bg">
      <div className="dz-page-header">
        <Link to={routes.login}>
          <img src="/images/datazoom_logo_xsml.svg" alt="" />
        </Link>
      </div>
      <div className="login-box signin">
        <div className="login-wrapper">
          <div className="login-content-box">
            <div className="login-logo">
              <Link to={routes.login}>
                <img src="/images/datazoom-logo-med-new.svg" alt="" />
              </Link>
            </div>
            <div className="login-txt">
              <p>
                The Real-time Data-as-a-Service Platform Capture - Process -
                Deliver
              </p>
            </div>
          </div>
          <div className="inner-login-wrapper">
            <h1>Log In</h1>
            <div className="sign-content">
              New to Datazoom?
              <Link
                className="sign-up-txt"
                to={routes.signup}
                onClick={
                  /* istanbul ignore next */ () => {
                    if (window.datazoom !== undefined) {
                      window.datazoom.generateEvent("click", {
                        target: "signup",
                      });
                    }
                  }
                }
              >
                {" "}
                Sign up today
              </Link>
            </div>
            <form>
              <div className="md-form custom-box">
                <input
                  label="Email address"
                  className="form-control w-100"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email Address"
                  error={!!(errors && errors.email)}
                  helperText={errors ? errors.email : ""}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  value={user ? user.email : ""}
                  autoComplete="off"
                />
              </div>

              <div className="md-form custom-box">
                <input
                  label="Password"
                  className="form-control w-100"
                  type={passwordType}
                  name="password"
                  id="password"
                  placeholder="Password"
                  error={!!(errors && errors.password)}
                  helperText={errors ? errors.password : ""}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  value={user ? user.password : ""}
                  autoComplete="off"
                />
                <div
                  className="input-addon-icon"
                  id="showPassword"
                  onClick={showPassword}
                >
                  <span id="basic-addon2">
                    {passwordType !== "text" ? (
                      <i className="icon-uniF127" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-eye-slash" aria-hidden="true" />
                    )}
                  </span>
                </div>
              </div>
            </form>
            <div className="mt-50 ">
              <button
                disabled={loginButton.disabled}
                type="submit"
                className="btn btn-raised btn-block submit-btn"
                onClick={onClick}
              >
                {loginButton.text}
              </button>
            </div>
            <p className="text-danger text-center">
              {errors ? errors.summary : ""}
            </p>

            <div className="row justify-content-between">
              <div className="col-12 forgot-wrap">
                <Link
                  to={routes.forgot_password_page}
                  className="forget-password"
                  onClick={
                    /* istanbul ignore next */ () => {
                      if (window.datazoom !== undefined) {
                        window.datazoom.generateEvent("click", {
                          target: "forgot password",
                        });
                      }
                    }
                  }
                >
                  Forgot Password
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
/* istanbul ignore next */
LoginForm.propTypes = {
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  loginButton: PropTypes.object.isRequired,
  showPassword: PropTypes.func.isRequired,
  passwordType: PropTypes.string.isRequired,
};

export default LoginForm;
